import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar"; // Adjust path as needed
import TopBar from "./NavBar";
import { AdminLibraryProvider } from "../Admin/AdminLibraryContext";
import "./portal.css";

const Layout = () => {
  const { pathname } = useLocation();
  // `/school` reuses the same librarian pages as `/librarian` and `/admin`, so it
  // needs the same `.lib-section` styling layer — without it those pages fall back
  // to raw Bootstrap (plain white table headers, unstyled cards/badges/buttons).
  const isLibrarian =
    pathname.startsWith("/librarian") ||
    pathname.startsWith("/admin") ||
    pathname.startsWith("/school");

  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const openMobileNav = () => setMobileNavOpen(true);
  const closeMobileNav = () => setMobileNavOpen(false);

  // Close the drawer whenever the route changes (e.g. tapping a menu link)
  useEffect(() => {
    setMobileNavOpen(false);
  }, [pathname]);

  // Prevent the page underneath from scrolling while the mobile drawer is
  // open, so a background swipe doesn't fight the open sidebar.
  useEffect(() => {
    if (!mobileNavOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [mobileNavOpen]);

  return (
    <AdminLibraryProvider>
      <div className="portal-shell">

        <Sidebar mobileOpen={mobileNavOpen} onClose={closeMobileNav} />

        {/* NOTE: content div must stay the ADJACENT sibling of .sidebar so the
            `.sidebar + div` layout offset in BookList.css still applies. The
            fixed-position backdrop is rendered after it (DOM order is irrelevant
            to its placement; its z-index handles stacking). */}
        <div className={isLibrarian ? "lib-section" : undefined} style={{ flex: 1, padding: "71px 0px 11px" }}>
          <TopBar onHamburger={openMobileNav} />
          <Outlet />
        </div>

        <div
          className={`sidebar-backdrop ${mobileNavOpen ? "show" : ""}`}
          onClick={closeMobileNav}
        />
      </div>
    </AdminLibraryProvider>
  );
};

export default Layout;
